import { api_DELETE, api_GET, api_GET_Unauthorize, api_POST, api_POST_files, api_PUT } from './_api';

const pgrs_api = {
    //Rotas do formulario do PGRS
    GetItem: (FormularioPGRSBloco_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PGRSFormulario/GetItem/${FormularioPGRSBloco_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PGRSFormulario/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListModalidadesFormularioPGRS: (formularioPGRS_Id = null) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PGRSFormulario/GetListModalidadesFormularioPGRS/${formularioPGRS_Id ? formularioPGRS_Id : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Update: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`PGRSFormulario/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Insert: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`PGRSFormulario/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },

    //Rotas do PGRS
    GetItemPGRSGerador: (pgrs_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PGRS/GetItemPGRSGerador/${pgrs_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListPGRS: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`PGRS/GetListPGRS/`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },

    InsertPGRSGerador: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`PGRS/InsertPGRSGerador`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    InsertAcaoAnaliseGestor: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`PGRS/InsertAcaoAnaliseGestor`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    UpdatePGRSGerador: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`PGRS/UpdatePGRSGerador`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostDocumentos: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_files("PGRS/InsertDocumentosPGRS", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    }
}

export default pgrs_api;